document.addEventListener('DOMContentLoaded', function () {
    const accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach(item => {
        const header = item.querySelector('.accordion-header');
        const content = item.querySelector('.accordion-content');

        header.addEventListener('click', function () {
            // Close all other items
            accordionItems.forEach(otherItem => {
                if (otherItem !== item && otherItem.classList.contains('active')) {
                    otherItem.classList.remove('active');
                    otherItem.querySelector('.accordion-content').style.height = '0px';
                    otherItem.querySelector('.accordion-header').style.fontWeight = '500';

                }
            });

            // Toggle current item
            if (item.classList.contains('active')) {
                item.classList.remove('active');
                content.style.height = '0px';
                header.style.fontWeight = '500';
            } else {
                item.classList.add('active');
                content.style.height = content.scrollHeight + 'px';
                header.style.fontWeight = '700';
            }
        });
    });
});